<template>
  <container>
    <checkout-progress reservation />
    <cart-reservation />
  </container>
</template>

<script>
import cartReservation from '../components/cartReservation.vue'
import checkoutProgress from '../components/checkoutProgress.vue'
import container from '../components/container.vue'

export default {
  name: 'VReservationOverview',

  components: {
    cartReservation,
    checkoutProgress,
    container
  },

  mounted () {
    this.$tracking.track(this.$route.path, 'r-ue')
    this.$tracking.eetCheckoutOverview()
  }
}
</script>
